import { BusinessOnboardingDetails } from '@nemuru-eng/js-api-client';

import { BusinessAddressDetailsEditDialog } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessAddressDetails/components/BusinessAddressDetailsEditDialog';
import { BusinessAddressDetailsForm } from '@/components/modules/KYC/KYCLoan/BusinessKYC/components/BusinessAddressDetails/components/BusinessAddressDetailsForm';
import { useBusinessDetailsActions } from '@/components/modules/KYC/KYCLoan/BusinessKYC/hooks/useBusinessDetailsActions';
import { useBusinessKyc } from '@/components/modules/KYC/KYCLoan/BusinessKYC/hooks/useBusinessKyc';
import { BusinessActions } from '@/components/modules/KYC/KYCLoan/BusinessKYC/types/BusinessActions';
import { useDialog } from '@/components/shared/hooks/useDialog';
import { PendingDataWarning } from '@/components/shared/components/PendingDataWarning';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { PendingDataType } from '@/config/types';

interface BusinessIdentificationProps {
  loanId: string;
  businessOnboarding: BusinessOnboardingDetails;
  editModeAllowed?: boolean;
}

export const BusinessAddressDetails = ({
  loanId,
  businessOnboarding,
  editModeAllowed,
}: BusinessIdentificationProps) => {
  const { opened, toggleDialog, setOpened } = useDialog();

  const { dialogAction, toggleEditModeDialog, businessBaseActionsOptions } = useBusinessDetailsActions({
    editModeAllowed,
    businessOnboarding,
    toggleDialog,
  });

  const { setBusinessDetailsToOnboardingDetails, loading } = useBusinessKyc({ loanId });

  return (
    <SubSectionWrapper
      title={'BUSINESS_ADDRESS'}
      specificActionsOptionsArray={toggleEditModeDialog && businessBaseActionsOptions}
    >
      {!businessOnboarding.businessDetails ? (
        <PendingDataWarning type={PendingDataType.BORROWER_ONBOARDING} />
      ) : (
        <>
          <BusinessAddressDetailsForm businessDetails={businessOnboarding.businessDetails} />
          {opened && dialogAction === BusinessActions.EDIT_DIALOG && (
            <BusinessAddressDetailsEditDialog
              businessDetails={businessOnboarding}
              opened={opened}
              setOpened={setOpened}
              toggleDialog={toggleDialog}
              setBusinessDetailsToOnboardingDetails={setBusinessDetailsToOnboardingDetails}
              loading={loading}
            />
          )}
        </>
      )}
    </SubSectionWrapper>
  );
};

export enum BusinessIdentificationAction {
  EDIT_DIALOG = 'edit_dialog',
}
